import moment from 'moment';
import { chunk, range } from 'lodash';

export const toEndOfMonth = date => moment(date).endOf('month');
export const toStartOfMonth = date => moment(date).startOf('month');
export const nextMonthStart = date => toStartOfMonth(date).add(1, 'month');
export const isSameMonth = (aDate, bDate) => toStartOfMonth(aDate).isSame(toStartOfMonth(bDate));
export const isNextMonth = (prior, next) => nextMonthStart(prior).isSame(toStartOfMonth(next));

/**
 * Get the months in the given year as moment objects at the start of each month
 *
 * @param {moment} year a moment object for the calendar year
 * @return {[month]} an array of months, each month being a moment object at midnight of the first day of the month
 */
export const monthsInYear = year => {
  const startOfYear = year.clone().startOf('year');
  return range(12).map(month => startOfYear.clone().add(month, 'month'));
};

/**
 * Get the months in the given year as moment objects set to the start of each month,
 * grouping the months into quarters.
 *
 * @param {moment} year a moment object for the calendar year
 * @return {[[month]]} an array of quarters in the year, each quarter being an array of the months in the quarter
 */
export const calendarYearQuarters = year => chunk(monthsInYear(year), 3);
